/* eslint-disable */ import { attachSingleReferenceComponent, childEntitySelectionComponent, composedOfComponent, memoEval, referenceComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { LynxProfessionalTapTowerKit } from '../model/index.js';
export const lynxProfessionalOutdoorBeverageDispenserW24Components = [
    attachSingleReferenceComponent(attachComponent.withComponent(referenceComponent, 'LynxProfessionalOutdoorBeverageDispenserW24.$towerKit', true).withEntity('LynxProfessionalOutdoorBeverageDispenserW24'), LynxProfessionalTapTowerKit, 'towerKitId'),
    attachComponent.withComponent(composedOfComponent, '$towerKit', true).withEntity('LynxProfessionalOutdoorBeverageDispenserW24').attach(memoEval((self)=>[
            self.$towerKit?.id ?? null
        ], (id)=>({
            childEntityIds: id === null ? [] : [
                id
            ]
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalOutdoorBeverageDispenserW24').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'REFRIGERATOR_LN24BF-1',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(childEntitySelectionComponent, 'towerKit', true).withEntity('LynxProfessionalOutdoorBeverageDispenserW24').attach(memoEval((self)=>[
            self.towerKitId,
            self.$towerKitOptions
        ], (towerKitId, $towerKitOptions)=>({
            value: towerKitId,
            options: $towerKitOptions
        })))
];

//# sourceMappingURL=lynx-professional-outdoor-beverage-dispenser-w-24.js.map